import ChevronDownEmptyIcon from './ChevronDownEmptyIcon'

export default ChevronDownEmptyIcon
